import type { Filters } from "../features/filters/types";
import type { StoreState } from "./types";
import { useAppStore } from "./useAppStore";

export const useSelector = <T>(selector: (state: StoreState) => T) => useAppStore(selector);

export const selectMobileFiltersOpen = (state: StoreState): boolean => state.mobileFiltersOpen;

export const selectMobileMapVisible = (state: StoreState): boolean => state.mobileMapVisible;

export const selectFilters = (state: StoreState): Filters => state.filters;

export const selectFiltersSearch = (state: StoreState): string => {
  const filters = selectFilters(state);

  return filters.search || "";
};

export const selectExcludedPhrases = (state: StoreState): string[] => {
  const filters = selectFilters(state);

  return filters.excludedPhrases || [];
};

export const selectFiltersStats = (
  state: StoreState,
): { appliedFiltersCount: number; appliedExcludedPhrases: number } => {
  const filters = selectFilters(state);

  const appliedFiltersCount =
    (filters.priceMin ? 1 : 0) +
    (filters.priceMax ? 1 : 0) +
    (filters.city ? 1 : 0) +
    (filters.shop?.length || 0) +
    (filters.caliber?.length || 0) +
    (filters.voivodeship?.length || 0) +
    (filters.available?.length || 0) +
    (filters.producer?.length || 0);

  const appliedExcludedPhrases = filters.excludedPhrases?.length || 0;

  return { appliedFiltersCount, appliedExcludedPhrases };
};
